<h3> SUBMISSION </h3>
<ul style="list-style-type: none">
	<li> Submission deadline: <b>COMPLETARE</b> </li>
	<li> Preliminary acceptance notification: COMPLETARE </li>
	<li> Final acceptance notification: COMPLETARE </li>
</ul>
<p>
	Conference contributions can be submitted via EasyChair
	using the following link <a
		href="COMPLETARE">COMPLETARE</a>.
</p>